// Deprecated: use ApexChat.EmojiUtils.createEmojiList() instead
export default class EmojiUtils {
    constructor() {
        this.emojiNames = [
            ':grinning_face:',
            ':grinning_face_with_smiling_face:',
            ':face_with_tears_of_joy:',
            ':smiling_face_with_open_mouth:',
            ':smiling_face_with_open_mouth_and_smiling_eyes:',
            ':smiling_face_with_open_mouth_and_cold_sweat:',
            ':smiling_face_with_open_mouth_and_tightly_closed_eyes:',
            ':smiling_face_with_halo:',
            ':smiling_face_with_horns:',
            ':winking_face:',
            ':smiling_face_with_smiling_eyes:',
            ':face_savouring_delicious_food:',
            ':relieved_face:',
            ':smiling_face_with_heart_shaped_eyes:',
            ':smiling_face_with_sunglasses:',
            ':smirking_face:',
            ':neutral_face:',
            ':expressionalLess_face:',
            ':unamused_face:',
            ':face_with_cold_sweat:',
            ':pensive_face:',
            ':confused_face:',
            ':confounded_face:',
            ':kissing_face:',
            ':face_throwing_a_kiss:',
            ':kissing_face_with_smiling_eyes:',
            ':kissing_face_with_closed_eyes:',
            ':disappointed_face:',
            ':worried_face:',
            ':angry_face:',
            ':pouting_face:',
            ':crying_face:',
            ':perserving_face:',
            ':face_with_look_of_triumph:',
            ':disappointed_but_relieved_face:',
            ':frowning_face_with_open_mouth:'
        ];
        this.emojiDecimalCodes = [
            '&#128512;',
            '&#128513;',
            '&#128514;',
            '&#128515;',
            '&#128516;',
            '&#128517;',
            '&#128518;',
            '&#128519;',
            '&#128520;',
            '&#128521;',
            '&#128522;',
            '&#128523;',
            '&#128524;',
            '&#128525;',
            '&#128526;',
            '&#128527;',
            '&#128528;',
            '&#128529;',
            '&#128530;',
            '&#128531;',
            '&#128532;',
            '&#128533;',
            '&#128534;',
            '&#128535;',
            '&#128536;',
            '&#128539;',
            '&#128541;',
            '&#128542;',
            '&#128543;',
            '&#128544;',
            '&#128545;',
            '&#128546;',
            '&#128547;',
            '&#128548;',
            '&#128549;',
            '&#128550;'
        ];
        // create a key-value pair to keep emoji, decimal
        this.mappingCodes = {};
        for (let i = 0; i < this.emojiNames.length; i++) {
            this.mappingCodes[this.emojiNames[i]] = this.emojiDecimalCodes[i].substring(2, 8);
        }
        // var emojiRegexArr = [];
        // for (var i = 0; i < emojiNames.length; i++) {
        //    emojiRegexArr[i] = new RegExp('\(' + emojiNames[i] + '\)', 'g');
        // }
        // create clickable emoji's list
        this.clickableEmojisList = [];
        for (let j = 0; j < this.emojiNames.length; j++) {
            let emoji = `<a href="#" tabindex="0" id="${this.emojiNames[j]}"><span class="livechat_emoticons_inner_span">${this.emojiDecimalCodes[j]}</span></a>`;
            if (j != 0 && j % 6 == 0) {
                emoji = `<br>${emoji}`;
            }
            this.clickableEmojisList.push(emoji);
        }
        // Pollyfill for String.fromCodePoint as per https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/fromCodePoint
        if (!String.fromCodePoint)
            (function (stringFromCharCode) {
                const fromCodePoint = function (_) {
                    const codeUnits = [];
                    let codeLen = 0;
                    let result = '';
                    for (let index = 0, len = arguments.length; index !== len; ++index) {
                        let codePoint = +arguments[index];
                        // correctly handles all cases including `NaN`, `-Infinity`, `+Infinity`
                        // The surrounding `!(...)` is required to correctly handle `NaN` cases
                        // The (codePoint>>>0) === codePoint clause handles decimals and negatives
                        if (!(codePoint < 1114111 && codePoint >>> 0 === codePoint))
                            throw RangeError(`Invalid code point: ${codePoint}`);
                        if (codePoint <= 65535) {
                            // BMP code point
                            codeLen = codeUnits.push(codePoint);
                        } else {
                            // Astral code point; split in surrogate halves
                            // https://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
                            codePoint -= 65536;
                            codeLen = codeUnits.push(
                                (codePoint >> 10) + 55296, // highSurrogate
                                (codePoint % 1024) + 56320 // lowSurrogate
                            );
                        }
                        if (codeLen >= 16383) {
                            result += stringFromCharCode.apply(null, codeUnits);
                            codeUnits.length = 0;
                        }
                    }
                    return result + stringFromCharCode.apply(null, codeUnits);
                };
                try {
                    // IE 8 only supports `Object.defineProperty` on DOM elements
                    Object.defineProperty(String, 'fromCodePoint', {
                        value: fromCodePoint,
                        configurable: true,
                        writable: true
                    });
                } catch (e) {
                    String.fromCodePoint = fromCodePoint;
                }
            })(String.fromCharCode);
        // Pollyfill for string's includes method which clickEmojis() uses; which crashes in an older IE; ref. https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
        if (!String.prototype.includes) {
            Object.defineProperty(String.prototype, 'includes', {
                value(search, start) {
                    if (typeof start !== 'number') {
                        start = 0;
                    }
                    if (start + search.length > this.length) {
                        return false;
                    }
                    return this.indexOf(search, start) !== -1;
                }
            });
        }
    }

    createEmojiList() {
        const me = this;
        return me.clickableEmojisList;
    }

    parse(text) {
        if (text) {
            for (let m = 0; m < this.emojiNames.length; m++) {
                text = text.replace(
                    this.emojiDecimalCodes[m],
                    `<span id='emojiContainer'>${this.emojiDecimalCodes[m]}</span>`
                );
            }
        }
        return text;
    }

    toEmoji(name) {
        const emojiInDecimal = this.mappingCodes[name];
        const emoji = String.fromCodePoint(Number(emojiInDecimal));
        return emoji;
    }
}
